export interface IssuerListResponse {
  id: string
  name: string
}

export class IssuerListModel {
  public id: string
  public name: string

  public constructor(r: IssuerListResponse) {
    this.id = r.id
    this.name = r.name
  }
}

export enum IssuerIntegrators {
  texasCapital = 'ii_13j1zhW5wOZ7R6MB42bwbx',
  amexDemo = 'ii_2D2EUrJoh356Lk6kBKJlPC',
  amex = 'ii_AuOipMMx0MC9RAkGBVG4fi',
  bmoTest = 'ii_0rso0NH0PM49YegFwpKIl4',
  hsbcDemo = 'ii_7rg6lwtXlsr7VS0xGJFdaB',
}
